module.exports = __webpack_public_path__ + "img/star3blue.cec326df.png";